import React, { useEffect, useMemo } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';
import { Helmet } from 'react-helmet';

import { withBullitenData } from 'containers/withBullitenData';
import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import TopButtonsGroup from 'components/TopButtonsGroup';
import InstructionsContent from './components/InstructionsContent';
import Loader from 'components/Loader';

import { useDisplayDocumentGTMEvent } from 'hooks/useDisplayDocumentGTMEvent';
import { getBreadcrumbs } from 'utils/documentsBreadcrumbsHelper';
import { getTitle } from 'utils/metaTitleHelper';

import styles from './FittingInstructions.module.scss';
const cx = classNames.bind(styles);

const FittingInstructions = ({ data, loading, location }) => {
  const showBackButton = location.state ? location.state.historyExist : false;
  const breadcrumbsSecondLevel = {
    fittingInstructions: {
      id: 2,
      active: true,
    },
  };
  const { title: pageTitle } = data;
  const title = useMemo(() => getTitle(pageTitle), [pageTitle]);
  const breadcrumbs = useMemo(
    () => getBreadcrumbs(data, breadcrumbsSecondLevel),
    [data, breadcrumbsSecondLevel]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useDisplayDocumentGTMEvent('Fitting Instructions', data);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={cx('gray-container')}>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Container>
        <Breadcrumbs data={breadcrumbs} />
        <TopButtonsGroup
          pageTitle={breadcrumbs.bulletin.title}
          showBackButton={showBackButton}
          documents={data.related_documents}
        />
        <InstructionsContent data={data} />
        <TopButtonsGroup
          showBackButton={false}
          documents={data.related_documents}
          pageTitle={breadcrumbs.bulletin.title}
        />
      </Container>
    </div>
  );
};

FittingInstructions.propTypes = {
  data: object.isRequired,
};

export default withBullitenData(FittingInstructions);



// WEBPACK FOOTER //
// ./src/pages/FittingInstructions/FittingInstructions.js